import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { firstValueFrom } from 'rxjs';
import { Ambito } from 'src/app/services/ambiti/ambiti.service';
import { AziendaService } from 'src/app/services/azienda/azienda.service';
import { BilancioService } from 'src/app/services/bilancio/bilancio.service';
import { MaterialitaService } from 'src/app/services/materialita/materialita.service';
import { PianoService } from 'src/app/services/piano/piano.service';
import { PolicyService } from 'src/app/services/policy/policy.service';
import { Settore } from 'src/app/services/settori/settori.service';
import { SintesiService } from 'src/app/services/sintesi/sintesi.service';
import { Tematica } from 'src/app/services/tematiche/tematiche.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay.component';
import {
  BottomSheetInfoElementiComponent,
  InfoElemento,
} from './bottom-sheet-info-elementi/bottom-sheet-info-elementi.component';
import { DialogAssociaFiguraAziendaleComponent } from './dialog/dialog-associa-figura-aziendale/dialog-associa-figura-aziendale.component';

@Component({
  selector: 'app-selezione-elementi-questionario',
  templateUrl: './selezione-elementi-questionario.component.html',
  styleUrls: ['./selezione-elementi-questionario.component.scss'],
  standalone: false,
})
export class SelezioneElementiQuestionarioComponent implements OnInit {
  @HostBinding('class.selezione-elementi-questionario') cssClass = true;

  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild('tabGroupAmbiti') tabGroupAmbiti!: MatTabGroup;

  @Output()
  public salvato = new EventEmitter<void>();

  private _objQuestionario: any;
  private _chiaveElementoSelezione: string = '';
  private _chiaveElemento: string = '';
  private _idContest: string = '';
  private _idAzienda: string | undefined = undefined;
  public referente: string = '';
  public _stato: string | undefined = undefined;
  public _isMaterialitaSelezionata: boolean = false; //solo per Bilancio e Sintesi ( se la materialità è stata selezionata nella cfg)
  public _isImpatto: boolean = false;
  public _isSoglieSuperate: boolean = false;
  private _settore: Settore[] = [];
  public isProfessionista: boolean = false;
  private arrayTematicheNonCompletata: string[] = [];

  public _titoloObiettivo: string | undefined;
  public _desObiettivo: string | undefined;
  public _nomeModulo: string | undefined;
  public _prioritaStep: string | undefined;

  @Input()
  set objQuestionario(objQuestionario: any) {
    this._objQuestionario = objQuestionario;
    this.updateFormStatus();
  }
  get objQuestionario() {
    return this._objQuestionario;
  }

  @Input()
  set chiaveElemento(chiaveElemento: any) {
    this._chiaveElemento = chiaveElemento;
  }
  get chiaveElemento() {
    return this._chiaveElemento;
  }
  @Input()
  set chiaveElementoSelezione(chiaveElementoSelezione: string) {
    this._chiaveElementoSelezione = chiaveElementoSelezione;
  }
  get chiaveElementoSelezione() {
    return this._chiaveElementoSelezione;
  }
  @Input()
  set idContest(idContest: any) {
    this._idContest = idContest;
  }
  get idContest() {
    return this._idContest;
  }
  @Input()
  set isSoglieSuperate(isSoglieSuperate: boolean) {
    this._isSoglieSuperate = isSoglieSuperate;
  }
  get isSoglieSuperate() {
    return this._isSoglieSuperate;
  }

  @Input()
  set stato(stato: string | undefined) {
    this._stato = stato;
  }
  get stato() {
    return this._stato;
  }

  @Input()
  set prioritaStep(prioritaStep: string | undefined) {
    this._prioritaStep = prioritaStep;
  }
  get prioritaStep() {
    return this._prioritaStep;
  }

  // Solo per il PIANO!!!!
  @Input()
  set titoloObiettivo(titoloObiettivo: string | undefined) {
    this._titoloObiettivo = titoloObiettivo;
  }
  get titoloObiettivo() {
    return this._titoloObiettivo;
  }

  // Solo per il PIANO!!!!
  @Input()
  set desObiettivo(desObiettivo: string | undefined) {
    this._desObiettivo = desObiettivo;
  }
  get desObiettivo() {
    return this._desObiettivo;
  }

  @Input()
  set nomeModulo(nomeModulo: string | undefined) {
    this._nomeModulo = nomeModulo;
  }
  get nomeModulo() {
    return this._nomeModulo;
  }

  @Input()
  set settore(settore: Settore[]) {
    this._settore = settore;
  }

  get settore() {
    return this._settore;
  }

  @Input()
  set isImpatto(isImpatto: boolean) {
    this._isImpatto = isImpatto;
  }

  get isImpatto() {
    return this._isImpatto;
  }

  private _isPermessoSoloRead = false;
  @Input()
  set isPermessoSoloRead(isPermessoSoloRead: boolean) {
    this._isPermessoSoloRead = isPermessoSoloRead;
  }
  get isPermessoSoloRead() {
    return this._isPermessoSoloRead;
  }

  private readonly _etichetteTipiElementoPerBox: { [key: string]: string } = {
    impegno: 'Impegni aziendali',
    kpi: 'Indicatori quantitativi [KPI]',
    impatto: 'Impatti',
    azionebp: 'Azioni e Buone pratiche aziendali',
    certif: 'Certificazioni aziendali',
    targetQualitativi: 'Target Qualitativi',
    targetQuantitativi: 'Target Quantitativi',
    obiettivo: 'Obiettivi',
  };

  formValido = new FormControl<boolean>(false, {
    validators: [Validators.requiredTrue],
  });

  constructor(
    public materialitaService: MaterialitaService,
    public bilancioService: BilancioService,
    public sintesiService: SintesiService,
    public dialog: MatDialog,
    public utilityService: UtilityService,
    private readonly aziendaService: AziendaService,
    private readonly utenteService: UtenteService,
    public policyService: PolicyService,
    public pianoService: PianoService,
    private readonly _bottomSheet: MatBottomSheet,
  ) {
    this.aziendaService.azienda.then((azienda) => {
      this._idAzienda = azienda?.id;
    });

    if (!this.utenteService.isPermessoAttivo('EDIT_UNITA_MISURA')) {
      this.isProfessionista = true;
    }
  }

  ngOnInit(): void {
    this._listaFigureAz();
  }

  onTabChange(event: MatTabChangeEvent) {}

  nrElemSel(elem: any) {
    return elem.elementi.filter((el: any) => el.selected).length;
  }

  /**
   * Controllo se la tematica passata che abbia almeno un elemento checkato
   * se è vero allora rimuovo dall arrayTematicheNonCompletata la tematica con l'elemento checkato
   * altrimento lo aggiunge per un futuro controllo (almeno 1 elemento per tematica)
   * @param idAmbito
   * @param idTematica
   */
  gestioneArrayTematicheNonCompletata(idAmbito: string, idTematica: string) {
    const ambito = this.objQuestionario.find((ambito: any) => ambito.id === idAmbito);

    if (!ambito) return;

    const tematica = ambito.tematiche.find((tematica: any) => tematica.id === idTematica);

    if (!tematica) return;

    const elementiSelezionati = tematica.elementi.filter((elemento: any) => elemento.selected);
    const tematicaKey = `${idAmbito}_${idTematica}`;
    const indiceTematicaNonCompleta = this.arrayTematicheNonCompletata.indexOf(tematicaKey);

    if (elementiSelezionati.length === 0) {
      // Aggiungi la tematica alla lista se non è già presente
      if (indiceTematicaNonCompleta < 0) {
        this.arrayTematicheNonCompletata.push(tematicaKey);
      }
    } else {
      // Rimuovi la tematica dalla lista se è stata completata
      if (indiceTematicaNonCompleta >= 0) {
        this.arrayTematicheNonCompletata.splice(indiceTematicaNonCompleta, 1);
      }
    }
  }

  scrollToElement(idAmbito: string, idTematica: string, idElemento: string) {
    let elementiSelezionati = this.oggettoElementiSelezionati();

    /* Controllo tutte le tematiche cosi non mi rimane in rosso una tematica già selezionata, perchè ora
    controllava solamente la tematica dove si azionava. 
    */
    for (let elem of elementiSelezionati) {
      this.gestioneArrayTematicheNonCompletata(elem.idAmbito, elem.idTematica);
    }

    let elTematica = document.getElementById(
      idAmbito + '_' + idTematica + this.chiaveElementoSelezione,
    );
    let el = document.getElementById(idAmbito + '_' + idTematica + '_' + idElemento);
    setTimeout(() => {
      if (idElemento) {
        el?.scrollIntoView({ behavior: 'smooth' });
      } else {
        elTematica?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  }

  editElementoListaChk(
    idAmbito: string,
    idTematica: string,
    elementoDaModificare: any,
    tematica?: Tematica,
  ): void {}

  /**
   * Se elemento nuovo creato dal modulo, allora gli aggiungo il settore del modulo
   */
  addSettoreElemento(elemento: any) {
    const obj = elemento || {};

    if (!obj.settori?.length) {
      obj.settori = this.settore?.length ? [...this.settore] : [];
    }

    return obj;
  }

  addElementoListaChk(idAmbito: string, idTematica: string): void {}

  associaFiguraAziendale(
    idAmbito: string,
    idTematica: string,
    idElemChk: string,
    figura: any,
  ): void {
    const dialogAssociaFiguraAziendale = this.dialog.open(DialogAssociaFiguraAziendaleComponent, {
      data: {
        figura: figura,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });
    dialogAssociaFiguraAziendale.afterClosed().subscribe((result) => {
      // ritorna id della figura aziendale
      if (result) {
        this.salvaFigAz(idAmbito, idTematica, idElemChk, result);
      }
    });
  }

  salvaFigAz(
    idAmbito: string,
    idTematica: string,
    idElemChk: string,
    idFigAziendale: string,
  ): void {}

  /**
   * Metodo che mi controlla se lo step è valido per andare avanti
   * @param msgChiave
   * @returns
   */
  ctrStepper(msgChiave: string): boolean {
    if (this._nomeModulo === 'BILANCIO' && this.prioritaStep !== 'OBBLIGATORIO') {
      return false;
    }

    let elementiSelezionati = this.oggettoElementiSelezionati();
    //Controllo se è stato selezionato almeno un impatto per tematica
    return this.ctrElemChecked(elementiSelezionati, msgChiave);
  }

  /**
   * Funzione che mi genera un oggetto per passare come parametro al salvataggio
   * dello step 3
   * @returns ogggetto per salvattagio step 3
   */
  oggettoElementiSelezionati() {
    let nuovoOggetto: any = [];

    this.objQuestionario.forEach((ambito: any) => {
      ambito.tematiche.forEach((tematica: any) => {
        nuovoOggetto.push({
          idAmbito: ambito.id,
          idTematica: tematica.id,
          idElementi: tematica.elementi
            .filter((elemento: any) => elemento.selected)
            .map((elemento: any) => elemento.id),
        });
      });
    });
    return nuovoOggetto;
  }

  /**
   * Metodo che mi contorlla se selezionato almeno un elemento per tematica
   * @param ambiti
   * @returns [true] no elementi checked per tematica  [false] almeno 1 elemento per tematica checked.
   */
  ctrElemChecked(oggetto: any, nominativoElemento?: string): boolean {
    this.arrayTematicheNonCompletata = [];

    if (!nominativoElemento) {
      nominativoElemento = 'elemento';
    }

    for (let elem of oggetto) {
      if (elem.idElementi <= 0) {
        this.arrayTematicheNonCompletata.push(elem?.idAmbito + '_' + elem?.idTematica);
      }
    }

    return this.cambioTabEvidenzioElemento(nominativoElemento);
  }

  /**
   * Metodo che mi evidenzia la tematica non selezionata e cambia tab se questa tematica si trova in una tab diversa
   * @param nominativoElemento
   */
  cambioTabEvidenzioElemento(nominativoElemento?: string): boolean {
    if (this.arrayTematicheNonCompletata.length) {
      this.cambioTab();

      setTimeout(() => {
        let el = document.getElementById(
          this.arrayTematicheNonCompletata[0] + this.chiaveElementoSelezione,
        );
        el?.scrollIntoView({ behavior: 'smooth' });
        this.utilityService.openSnackBar(
          'Selezionare almeno un ' + nominativoElemento + ' per tematica ',
          '',
          {
            duration: 2000,
            panelClass: ['red-snackbar'],
          },
        );
      }, 0);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Cambio tab se ho elementi obbligatori da checkare in un altra tab
   */
  cambioTab() {
    const idxTab = (this.objQuestionario as Ambito[]).findIndex((amb: Ambito) => {
      return amb.id === this.arrayTematicheNonCompletata[0].split('_')[0];
    });
    this.tabGroupAmbiti.selectedIndex = idxTab;
  }

  updateFormStatus() {
    const elSenzaSel = this.objQuestionario.find((ambito: any) => {
      return ambito.tematiche.find((tematica: any) => {
        return !tematica.elementi.find((impegno: any) => impegno.selected);
      });
    });

    this.formValido.setValue(elSenzaSel ? false : true);

    this.ordinaAmbiti();

    this.ristrutturazioneOggettoABox();
  }

  /**
   * Metodo che ordina le tab ambiti per index (campo ordinamento dalla cfg).
   */
  ordinaAmbiti() {
    this._objQuestionario = this._objQuestionario.sort((a: any, b: any) => {
      let indexA = a.index ?? Infinity;
      let indexB = b.index ?? Infinity;
      return indexA - indexB;
    });
  }

  /**
   * Funzione che mi prende la figura referente
   */
  private _listaFigureAz() {
    if (this._idAzienda) {
      this.aziendaService.getFigureAz(this._idAzienda, 0, 1000).subscribe({
        next: (esito) => {
          this.referente = esito.content
            .filter((item: any) => item.figura.toLowerCase() === 'referente')
            .map((item: any) => item.figura + ' : ' + item.nome);
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }

  /**
   * Metodo che viene lanciato nel momento del check elemento.
   * @param elementoChk
   * @param checked
   * @param idAmbito
   * @param idTematica
   * @returns
   */
  selezionaCheck(elementoChk: any, checked: boolean, idAmbito: string, idTematica: string) {
    if (this.isPermessoSoloRead) {
      return;
    }
    if (!this.controlloElementoDisabled(elementoChk)) {
      elementoChk.selected = checked;
      this.updateFormStatus();

      /* Controllo che una volta checkato, i campi obbligatori dentro l'elemento non siano vuoti 
         Viene utilizzato per impatti e impegni per adesso. L'implementazione si trova nelle proprie classi  */
      this.ctrCheck(idAmbito, idTematica, elementoChk, checked);
    }
  }

  ctrCheck(idAmbito: string, idTematica: string, elementoChk: any, checked: boolean) {}

  /**
   * Metodo che mi valorizza il tooltip della della figura
   * @param figura figura
   */
  toolTipFigura(figura: any): string {
    let tooltip: string | undefined = undefined;
    if (figura) {
      tooltip = figura?.figura + ' : ' + figura?.nome;
    } else {
      tooltip = this.referente;
    }

    return tooltip;
  }

  controlloElementoDisabled(elementoChk: any): boolean {
    if (this.stato === 'PUBBLICATO' || this.isElementoObbligatorio(elementoChk)) {
      return true;
    }
    return false;
  }

  isElementoEditable(elementoChk: any) {
    if (this.isPermessoSoloRead) {
      return false;
    }

    if (!this.controlloElementoDisabled(elementoChk)) {
      return true;
    }
    return false;
  }

  /**
   * Elemento obbligatorio
   * Non obbligatorio per impegni e certificazioni
   * @param elementoChk
   * @returns
   */
  isElementoObbligatorio(elementoChk: any) {
    const isPreSelected = elementoChk?.preSelected;
    const isImpatto = elementoChk?.tipo === 'Impatto';
    const isKpiAzione = ['AzioniEBuonePratiche', 'Kpi'].includes(elementoChk?.tipo);

    // Controllo se azioni e kpi sono obbligaotri per soglie superata e stdr obbligatori
    if (isKpiAzione && elementoChk?.infoConsigliatoObbl?.stdrObbligatori?.length) {
      return true;
    }

    // PER IMPATTI
    /*   if (isPreSelected && isImpatto && elementoChk?.materiale && elementoChk?.preSelectedInfos?.length) {
        return true;
      } */

    return false;
  }

  /**
   * Elemento consigliato
   * @param elementoChk
   * @returns
   */
  isElementoConsigliato(elementoChk: any) {
    // Se è obbligatorio non è consigliato
    if (this.isElementoObbligatorio(elementoChk)) {
      return false;
    }

    const isKpiAzione = ['AzioniEBuonePratiche', 'Kpi'].includes(elementoChk?.tipo);
    const isInfoPresent =
      elementoChk?.infoConsigliatoObbl?.stdrConsigliati?.length ||
      elementoChk?.preSelectedInfos?.length ||
      elementoChk?.infoConsigliatoObbl?.consigliatoModuliAssociati?.length;
    const isCertImpegno = ['Certificazione', 'Impegno'].includes(elementoChk?.tipo);

    // Controllo se AZIONI e KPI sono consigliati per soglie non superate e stdr consigliati
    if (isKpiAzione && isInfoPresent) {
      return true;
    }

    if (isCertImpegno && isInfoPresent) {
      return true;
    }

    // Controllo consigliato per IMPATTO
    if (elementoChk.tipo === 'Impatto' && (elementoChk?.consigliato || elementoChk?.materiale)) {
      return true;
    }

    return false;
  }

  /**
   * Mostro icona del obbligatorio
   * @param elementoChk
   * @returns
   */
  /*   showLockIcon(elementoChk: any): boolean {
      const isObbligatorio = this.isElementoObbligatorio(elementoChk);
      const isPreSelected = elementoChk?.preSelected;
      const isImpatto = elementoChk?.tipo === 'Impatto';
   
      // PER ELEMENTI KPI E AZIONI NEL CONTESTO BILANCIO
      if (isObbligatorio) {
        return true;
      }
   
      // PER IMPATTI
      if (isPreSelected) {
        if (isImpatto && elementoChk?.materiale) {
          return true;
        }
      }
      return false;
    } */

  tooltipInfo(infos?: any, tematica?: boolean, materiale?: boolean): string[] {
    const infoList: string[] = [];
    if (infos?.length) {
      infos = [...new Set(infos)];
      infos?.forEach((info: string) => {
        const [codice, anno] = info.split('_');

        switch (codice) {
          case 'MA': {
            if (tematica) {
              infoList.push(
                `Tematica definita nell'Analisi di Materialità dell' [${anno}] associata al Report`,
              );
            } else {
              const impattoText = this._nomeModulo === 'BILANCIO' ? 'Impatto materiale' : 'Impatto';
              infoList.push(
                `${impattoText} definito nell'Analisi di Materialità dell' [${anno}] associata al Report`,
              );
            }
            break;
          }
          case 'PA':
            infoList.push('Policy di Sostenibilità ' + '[' + anno + ']');
            break;

          case 'SA':
            infoList.push('Sintesi di Sostenibilità ' + '[' + anno + ']');
            break;

          case 'AA':
            infoList.push('Assessment di Sostenibilità ' + '[' + anno + ']');
            break;

          case 'PI':
            infoList.push('Piano di Sostenibilità ' + '[' + anno + ']');
            break;
          case 'BA':
            infoList.push('Report di Sostenibilità ' + '[' + anno + ']');
            break;
          case 'DM': {
            if (tematica) {
              infoList.push(
                `Tematica definita nell'Analisi di Doppia Materialità dell' [${anno}] associata al Report di Sostenibilità`,
              );
            } else {
              const impattoText = materiale ? 'Impatto materiale' : 'Impatto';
              infoList.push(
                `${impattoText} definito nell'Analisi di Doppia Materialità dell' [${anno}] associata al Report`,
              );
            }
            break;
          }
          default:
        }
      });
    }
    return infoList;
  }

  /**
   * arrayTematicheNonCompletata ha come valori una lista di elementi [idAmbito_Tematica], quindi tematiche
   * che non hanno nessun elemento checkato.
   * @param idAmbito_Tematica
   * @returns
   */
  ctrTematicaNonCompletata(idAmbito_Tematica?: string) {
    if (this.nomeModulo !== 'BILANCIO' || this.prioritaStep === 'OBBLIGATORIO') {
      if (idAmbito_Tematica && this.arrayTematicheNonCompletata.includes(idAmbito_Tematica)) {
        return true;
      }
    }
    return false;
  }

  apriPopUpConsigliato(elementoChk: any) {
    const infoElementoObj: InfoElemento = {
      infos: this.tooltipInfo(
        (elementoChk?.preSelectedInfos ?? []).concat(
          elementoChk?.infoConsigliatoObbl?.consigliatoModuliAssociati ?? [],
        ),
        false,
        elementoChk?.materiale,
      ),
      stdr: elementoChk?.infoConsigliatoObbl?.stdrConsigliati,
      titoloElemento: elementoChk?.titolo,
      obbligatorio: false,
    };

    this._bottomSheet.open(BottomSheetInfoElementiComponent, { data: infoElementoObj });
  }

  apriPopUpConsigliatoTematica(teamtica: Tematica) {
    const infoElementoObj: InfoElemento = {
      infos: this.tooltipInfo(teamtica?.infoConsigliatoObbl?.consigliatoModuliAssociati, true),
      stdr: teamtica?.infoConsigliatoObbl?.stdrConsigliati ?? [],
      titoloElemento: teamtica?.domanda,
      obbligatorio: false,
    };

    this._bottomSheet.open(BottomSheetInfoElementiComponent, { data: infoElementoObj });
  }

  apriPopUpObbligatorio(elementoChk: any) {
    const infoElementoObj: InfoElemento = {
      infos: this.tooltipInfo(
        (elementoChk?.preSelectedInfos ?? []).concat(
          elementoChk?.infoConsigliatoObbl?.consigliatoModuliAssociati ?? [],
        ),
      ),
      stdr: elementoChk?.infoConsigliatoObbl?.stdrObbligatori,
      titoloElemento: elementoChk?.titolo,
      obbligatorio: true,
    };

    this._bottomSheet.open(BottomSheetInfoElementiComponent, { data: infoElementoObj });
  }

  ristrutturazioneOggettoABox() {
    this._objQuestionario.forEach((ambito: any) => {
      ambito.tematiche.forEach((tematica: any) => {
        let titoloPanel = '';

        tematica.oggettoPerBox = [
          {
            nomeBox: titoloPanel,
            idBox: 'stdr',
            elementi: tematica.elementi.filter((el: any) => {
              const isConsigliato = this.isElementoConsigliatoPerSTDR(el);

              // Genero il titolo del panel
              if (isConsigliato) {
                // Se l'elemento è obbligatorio allora prendo il codice stdr solo per gli obbligatori, altrimenti anche per consigliati
                const stdrCodes = this.isElementoObbligatorio(el)
                  ? el?.infoConsigliatoObbl?.stdrObbligatori
                  : el?.infoConsigliatoObbl?.stdrObbligatori?.concat(
                      el?.infoConsigliatoObbl?.stdrConsigliati || [],
                    );

                stdrCodes.forEach((stdr: any) => {
                  if (!titoloPanel.includes(stdr.codice)) {
                    titoloPanel += titoloPanel ? ` - ${stdr.codice}` : stdr.codice;
                  }
                });
              }
              return isConsigliato;
            }),
            expanded: true,
          },

          {
            nomeBox: 'Consigliati',
            idBox: 'consigliati',
            elementi: tematica.elementi.filter(
              (el: any) =>
                (el.preSelectedInfos?.length ||
                  el?.infoConsigliatoObbl?.consigliatoModuliAssociati?.length) &&
                !this.isElementoConsigliatoPerSTDR(el),
            ),
            expanded: tematica.elementi.some(
              (el: any) =>
                el.selected &&
                (el.preSelectedInfos?.length ||
                  el?.infoConsigliatoObbl?.consigliatoModuliAssociati?.length) &&
                !this.isElementoConsigliatoPerSTDR(el),
            ),
          },

          {
            nomeBox: this._etichetteTipiElementoPerBox[this.chiaveElementoSelezione],
            idBox: 'altro',
            elementi: tematica.elementi.filter(
              (el: any) => !this.isElementoConsigliato(el) && !this.isElementoObbligatorio(el),
            ),
            expanded: false,
          },
        ];

        // Assegno il valore finale al nomeBox dopo aver popolato gli elementi per box stdr
        tematica.oggettoPerBox[0].nomeBox = titoloPanel;

        // Gestione expand su box Altro

        const isBoxStdrConElem =
          tematica.oggettoPerBox[0].elementi.length > 0 &&
          tematica.oggettoPerBox[0].idBox === 'stdr';
        const isBoxConsigliatiConElem =
          tematica.oggettoPerBox[1].elementi.length > 0 &&
          tematica.oggettoPerBox[1].idBox === 'consigliati';
        const isBoxAltroConElem =
          tematica.oggettoPerBox[2].elementi.length > 0 &&
          tematica.oggettoPerBox[2].idBox === 'altro';

        if (!isBoxStdrConElem && !isBoxConsigliatiConElem && isBoxAltroConElem) {
          tematica.oggettoPerBox[2].expanded = true;
        }
      });
    });
  }

  /**
   * Visualizza box
   */
  visualizzaBox(box: any, tematica: Tematica): boolean {
    if (box.elementi.length || this.mostraAggiungiNuovo(box, tematica)) {
      return true;
    }
    return false;
  }

  isElementoConsigliatoPerSTDR(elem: any): boolean {
    const isKpiAzione = ['AzioniEBuonePratiche', 'Kpi'].includes(elem?.tipo);

    if (
      isKpiAzione &&
      (elem?.infoConsigliatoObbl?.stdrObbligatori?.length ||
        elem?.infoConsigliatoObbl?.stdrConsigliati?.length)
    ) {
      return true;
    }

    return false;
  }

  /**
   *  Manda alert SE step consigliato
      - IMPATTI : Step consigliato per STDR = tematica consigliata per lo stesso STDR, e non selezionato almeno 1 elemento.  
      - IMPEGNI : Step consigliato per SRDR = Tematica consigliata per STDR, e non selezionato almeno 1 elemento.
      - AZIONI  : Step consigliato per STDR = Tematica consigliata per STDR = Elemento consigliato per STDR, e non selezionato tutti gli elementi. (match di tutti i 3)
      - KPI     : Step consigliato per STDR = Tematica consigliata per STDR = Elemento consigliato per STDR, e non selezionato tutti gli elementi. (match di tutti i 3)
      - CERTIF  : Step consigliato per SRDR = Tematica consigliata per STDR, e non selezionato almeno 1 elemento.
   * @param descrizioneAlert
   * @param stdrStep STDR per il quale lo step è stato consigliato 
   * @param step Nome step (impatti, impegni etc...)
   * @returns Esito alert
   */
  async ctrElemIsCheckedForConsigliato(
    descrizioneAlert: string,
    stdrStep: string[] | undefined,
    step: string,
  ): Promise<boolean> {
    const isKpiAzione = ['AZIONIBP', 'KPI'].includes(step);

    let nuovoOggetto: any = [];

    let stdrNonSelezioanto: string[] = [];

    this.objQuestionario.forEach((ambito: Ambito) => {
      // Mi filtro le tematiche che sono consigliate per almeno uno STDR dello step in cui sono
      const tematicheFiltratePerStdr: Tematica[] = ambito.tematiche.filter(
        (tem) =>
          tem.consigliato &&
          tem.infoConsigliatoObbl?.stdrConsigliati?.some((stdr) => stdrStep?.includes(stdr.codice)),
      );

      tematicheFiltratePerStdr.forEach((tematica: Tematica) => {
        // Dato che questi elementi non hanno la cfg STDR allora controllo che sia selezionato alemno un elemento per tematica
        if (!isKpiAzione) {
          nuovoOggetto.push({
            idAmbito: ambito.id,
            idTematica: {
              id: tematica.id,
              domanda: tematica.domanda,
            },
            idElementi: tematica.elementi
              .filter((elemento: any) => elemento.selected)
              .map((elemento: any) => elemento.id),
          });
        } else {
          /*Se gli elementi hanno anche STDR allora devo controllare anche il loro stdr (kpi - azioniBP)
            Ovvero che stdr dell'elemento sia uguale a quello della tematica */

          // Codici STDR della tematica
          let codiciStdrTematica: string[] =
            tematica.infoConsigliatoObbl?.stdrConsigliati?.map((stdr) => stdr.codice) ?? [];
          // Filtro i codici STDR della tematica che corrisponde a quello dello step.
          codiciStdrTematica = codiciStdrTematica.filter((cod) => stdrStep?.includes(cod));

          // Codici STDR di tutti gli elementi selezionati della tematica.
          const codiciStdrElementi: string[] = tematica.elementi
            .filter(
              (elemento: any) =>
                !elemento.selected && elemento.infoConsigliatoObbl?.stdrConsigliati,
            )
            .flatMap((elemento: any) =>
              elemento.infoConsigliatoObbl.stdrConsigliati.map((stdr: any) => stdr.codice),
            );

          // Rimuovo codici STDR duplicati
          const codiciStdrElementiUnici = [...new Set(codiciStdrElementi)];

          // Mi filtro i codici stdr mancanti degli elementi sulla tematica
          stdrNonSelezioanto = codiciStdrTematica.filter((item) =>
            codiciStdrElementiUnici.includes(item),
          );

          // Se tutti i codici STDR corrispondono allora non devo controllare la tematica perchè sarebbe coretta.
          if (!stdrNonSelezioanto.length) {
            return;
          }

          nuovoOggetto.push({
            idAmbito: ambito.id,
            idTematica: {
              id: tematica.id,
              domanda: tematica.domanda,
            },
            idElementi: tematica.elementi
              .filter(
                (elemento: any) =>
                  !elemento.selected &&
                  elemento.infoConsigliatoObbl.stdrConsigliati.some((stdr: any) =>
                    stdrNonSelezioanto?.includes(stdr.codice),
                  ),
              )
              .map((elemento: any) => ({
                id: elemento.id,
                titolo: elemento.titolo,
                stdr: elemento.infoConsigliatoObbl.stdrConsigliati
                  .filter((stdr: any) => stdrNonSelezioanto?.includes(stdr.codice))
                  .map((stdr: any) => stdr.codice),
              })),
          });
        }
      });
    });

    // Se esiste una tematica consiglaita e non ha un elemento selezionato che corrisponda al suo STDR, allora mando un alert
    const mostraAlert: boolean = isKpiAzione
      ? nuovoOggetto.some((elem: any) => elem.idElementi.length > 0)
      : nuovoOggetto.some((elem: any) => elem.idElementi.length === 0);

    if (mostraAlert) {
      // Descrizione dell'alert
      descrizioneAlert += `
          <br><br>
          <strong><span style="font-size: 14px;">Tematiche consigliate:</span></strong>
          <ul style="padding-left: 30px; margin: 5px 0px 0px 0px; font-size: 14px; font-weight: 500;">
      `;

      /**
       * Se sono non sono in un contesto (!isKpiAzione) allora filtro solamente le tematiche che non hanno elementi selezionati (questo perchè mi serve almeno un elemento x tematica)
       * Se sono in un contesto (isKpiAzione) allora filtro solamente gli elementi che non sono stati selezionati e che hanno lo stesso stdr della tematica. (lo fa già con la creazione dell'oggetto sopra)
       */
      const objMapAlert = isKpiAzione
        ? nuovoOggetto
        : nuovoOggetto.filter(
            (obj: any) => obj.idElementi.length === 0 || stdrNonSelezioanto.length,
          );

      descrizioneAlert += objMapAlert
        .map((obj: any) => {
          let spanText = '';

          // Mi mappo gli elementi che non sono stati selezionati e mostro il titolo e stdr per il quale è stato consigliato (kpi e azioni)
          if (obj.idElementi.length > 0 && isKpiAzione) {
            const elementoKpiAzione = obj.idElementi
              .map(
                (elem: any) =>
                  `<li>${elem.titolo} <span style="font-weight: 600;">[${elem.stdr.map((stdr: any) => stdr).join(', ')}]</span></li>`,
              )
              .join('');

            spanText = `
                  <span style="color: grey; font-size: 13px; font-weight: 400;">
                      <ul>${elementoKpiAzione}</ul>
                  </span>
              `;
          }

          // (tutti gli elementi)
          return `
              <li>
                  <span style="font-size: 13px;">
                      ${obj.idTematica.domanda}
                      ${spanText}
                  </span>
              </li>
          `;
        })
        .join('');

      // Chiusura della lista
      descrizioneAlert += '</ul>';

      // Mostro l'alert
      if (!(await this.alertConsigliatoPerStdr(descrizioneAlert))) {
        return false;
      }
    }

    return true;
  }

  /**
   * Alert per elemnti / tematiche consigliate
   */
  async alertConsigliatoPerStdr(descrizione: string) {
    const dialog = await this.utilityService.openDialog({
      titolo: 'Step consigliato',
      descrizione: descrizione,
      fontWeight: 'normal',
      bottoni: [
        {
          nome_btn: 'Chiudi',
          id_btn: 'C',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'Avanti',
          id_btn: 'A',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'C') {
      return false;
    }

    return true;
  }

  /**
   * mostro il bottone solamente se sono in box "altro", e lo nascondo
   * se sono in bilancio && la tematica è materiale && sono sullo step impatti
   */
  mostraAggiungiNuovo(box: any, tematica: Tematica): boolean {
    const nascondiBottone =
      tematica.materiale && this._isImpatto && this._nomeModulo === 'BILANCIO';

    if (box.idBox === 'altro' && !nascondiBottone) {
      return true;
    }
    return false;
  }

  /**
   * Ritorna una tematica filtrata per id ambito e id tematica
   */
  public getTematicaByIds(idAmbito: string, idTematica: string): Tematica | undefined {
    const ambito = this._objQuestionario.find((amb: Ambito) => amb.id === idAmbito);
    return ambito?.tematiche.find((tematica: Tematica) => tematica.id === idTematica);
  }
}
